import type { ProductPriceType } from "@jti/fe-common";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

type ViewItemEventData = {
  productName: string;
  sku: string;
  color: string | number | null;
  flavor: string | number | null;
  categories: { name: string }[];
  discount: number | null;
  priceInformation: ProductPriceType | null;
};

export const dispatchViewItemEvent = (payload: ViewItemEventData) => {
  const { productName, sku, color, flavor, categories, discount, priceInformation } = payload;

  const itemPrice = priceInformation?.finalPrice?.value || "N/A";

  dispatchTrackingEvent(TrackingEvents.TrackingViewItem, {
    value: itemPrice,

    ecommerce: {
      items: [
        {
          item_id: sku || productName,
          currency: priceInformation?.finalPrice?.currency || "N/A",
          price: itemPrice,
          discount: discount || "N/A",
          quantity: 1,
          index: 0,
          item_brand: "ploom",
          item_category: categories?.[0]?.name || "N/A",
          item_category2: categories?.[1]?.name || "N/A",
          item_name: productName || "N/A",
          item_color: String(color || "N/A"),
          item_flavor: String(flavor || "N/A"),
          item_strength: "N/A",
          item_coupon: "N/A",
          item_coupon_type: "N/A",
          item_list_id: "N/A",
          item_list_name: productName || "N/A",
          item_rewards: "N/A",
          item_sku: sku,
          purchase_type: "N/A",
          carton_format: "N/A",
          carton_quantity: "N/A",
        },
      ],
    },
  }).then((res) => {
    if (res === false) {
      setTimeout(() => {
        dispatchViewItemEvent(payload);
      }, 1000);
    }
  });
};
